import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Title = styled.h1`
  font-size: 50px;
`;

export const StyledP = styled.p`
  font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
`;
